import React from 'react';
import * as styles from './imageSection.module.scss';
import { usePageContext } from '../context/pageContext';
import { SanityImageSection } from 'graphql-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Blocks } from '../ui/blocks/Blocks';
import { findTranslation } from '../../utils/findTranslation';

interface Props {
  section: SanityImageSection;
}

export const ImageSection: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();

  return (
    <div
      className={`${styles.wrapper} ${
        section?.backgroundColor === 'grey' && styles.wrapperBgGrey
      } ${section?.backgroundColor === 'white' && styles.wrapperBgWhite} ${
        section?.backgroundColor === 'black' && styles.wrapperBgBlack
      }`}
    >
      {section?.activeTitle && (
        <div className={styles.title}>
          <h2>{findTranslation(section?._rawTitle, lang, defaultLang)}</h2>
        </div>
      )}
      <div
        className={`${styles.container} ${section?.imagePosition === 'right' && styles.reverse} ${
          section?.imageDisplay === 'portrait' && styles.portrait
        }`}
      >
        <div className={styles.imageDesktop}>
          <GatsbyImage
            image={section?.imgDescription?.img?.asset?.gatsbyImageData}
            alt={section?.imgDescription?.alt ?? ''}
          />
        </div>
        <div className={styles.image}>
          <GatsbyImage
            image={section?.imgDescription?.img?.asset?.gatsbyImageData}
            alt={section?.imgDescription?.alt ?? ''}
          />
        </div>

        <div className={styles.content}>
          <Blocks blocks={findTranslation(section?._rawText, lang, defaultLang)} />
        </div>
      </div>
    </div>
  );
};
